import {
  INITIAL_STATE_RESERVATIONS,
  REQUEST_FETCH_ACTUAL_RESERVATIONS,
  FETCH_ACTUAL_RESERVATIONS_SUCCESS,
  FETCH_ACTUAL_RESERVATIONS_ERROR,
} from "../../../actions/b2b/availability/fetchActualReservationsByAgency";

const initialState = {
  actualReservations: [],
  processing: false,
  fetching: false,
  message: "",
  error: "",
};

const availabilityActualReservationsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case INITIAL_STATE_RESERVATIONS: {
      return {
        ...state,
        actualReservations: [],
        historicalReservations: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_FETCH_ACTUAL_RESERVATIONS: {
      return {
        ...state,
        actualReservations: [],
        historicalReservations: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_ACTUAL_RESERVATIONS_SUCCESS: {
      return {
        ...state,
        actualReservations: action.actualReservations,
        historicalReservations: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case FETCH_ACTUAL_RESERVATIONS_ERROR: {
      return {
        ...state,
        actualReservations: [],
        historicalReservations: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};

export default availabilityActualReservationsReducer;
